import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useActions } from '../../../hooks/useActions';
import { useStepper } from '../partials/actionStepperPartial';
import { UpdateEmployeesStepOne } from './steps/stepOne';
import { UpdateEmployeesStepThree } from './steps/stepThree';
import { UpdateEmployeesStepTwo } from './steps/stepTwo';

const BACK_TO_PATH = '/employees';

export const UpdateEmployees: FC = () => {
  const {
    activeStep,
    setTitle,
    setSectionTitle,
    setBackToPath,
    setBackToTitle,
    setStepperConfig,
    stepperConfig
  } = useStepper();
  const { selectedUsers, setSelectedUsers, selectedEmployees } = useActions();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Return to Overview Page if no users are selected
  useEffect(() => {
    if (!selectedEmployees || Object.keys(selectedEmployees).length === 0) {
      navigate(BACK_TO_PATH);
    } else {
      setSelectedUsers(Object.keys(selectedEmployees));
    }
  }, []);

  // Initialize Wrapper values
  useEffect(() => {
    setTitle(t('form:UPDATE_EMPLOYEES'));
    setBackToPath(BACK_TO_PATH);
    setBackToTitle(t('account:BACK_TO_OVERVIEW'));
    setStepperConfig([
      {
        title: t('form:UPDATE_EMPLOYEES_COUNT', { count: selectedUsers?.length })
      },
      {
        title: t('form:SUMMARY')
      }
    ]);
  }, [selectedUsers]);

  // control form steps
  useEffect(() => {
    if (stepperConfig && activeStep && activeStep > stepperConfig.length) {
      setSectionTitle(undefined);
    } else if (activeStep) {
      setSectionTitle(stepperConfig && stepperConfig[activeStep - 1].title);
    }
  }, [activeStep, stepperConfig]);

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      sx={{
        '& .pxtra-bold': {
          fontWeight: 'bold'
        }
      }}
    >
      {activeStep === 2 && <UpdateEmployeesStepTwo />}
      <UpdateEmployeesStepOne />
      {activeStep === 3 && <UpdateEmployeesStepThree />}
    </Box>
  );
};
